import { render, staticRenderFns } from "./TypeCell.vue?vue&type=template&id=3dd8f330&scoped=true"
import script from "./TypeCell.vue?vue&type=script&lang=ts"
export * from "./TypeCell.vue?vue&type=script&lang=ts"
import style0 from "./TypeCell.vue?vue&type=style&index=0&id=3dd8f330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd8f330",
  null
  
)

export default component.exports